import SimpleTable from "@/components/SimpleTable";
import { handleCompanyName, handleCompanyUserName } from "@/lib/handleName";
import { AssessmentProgress } from "@/schema/AssessmentProgress";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton";

interface SubmissionTableProps {
  data: AssessmentProgress[];
  isLoading: boolean;
}

function CheckSubmissionsTable({ data, isLoading }: SubmissionTableProps) {
  const { t } = useTranslation();
  return (
    <SimpleTable
      isLoading={isLoading}
      data={data}
      columns={[
        {
          key: "companyName",
          label: t("company-name"),
          render: ({ id, company_name }) => handleCompanyName(id, company_name),
        },
        {
          key: "status",
          label: t("status"),
          render: ({ status: { name } }) => (
            <span className="font-medium text-cool-gray-600">{name}</span>
          ),
        },
        {
          key: "assessmentDate",
          label: t("assessment-date"),
          render: ({ start_date, end_date }) => (
            <div>
              <div>
                {t("start-date")} :{" "}
                {start_date ? format(start_date, t("date-format")) : "---"}
              </div>
              <div>{end_date ? format(end_date, t("date-format")) : "---"}</div>
            </div>
          ),
        },
        {
          key: "submittedAt",
          label: t("submitted-at"),
          render: ({ submitted_at }) => {
            const date = submitted_at
              ? format(submitted_at, t("date-format"))
              : "----/--/-";
            const time = submitted_at
              ? format(submitted_at, t("time-format"))
              : "--:--";
            return (
              <div>
                <div className="font-medium text-cool-gray-600">{date}</div>
                <div className="text-cool-gray-600">{time}</div>
              </div>
            );
          },
        },
        {
          key: "submiitedBy",
          label: t("submitted-by"),
          render: ({ submitted_by }) =>
            submitted_by
              ? handleCompanyUserName(submitted_by.id, submitted_by.name)
              : "---",
        },
        {
          key: "action",
          label: t("action"),
          render: ({
            id,
            status: { id: statusId },
            has_improvement_proposal,
          }) => (
            <ActionButton
              id={id}
              status={statusId}
              hasImprovementProposal={has_improvement_proposal}
            />
          ),
        },
      ]}
    />
  );
}

export default CheckSubmissionsTable;
